import { useAppDispatch, useAppSelector } from '@/state/hooks';
import {
    selectXplorTraderMobileLayoutNode,
    setXplorTraderMobileLayoutNode
} from '@/state/reducers/xplorTraderLayoutSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import { DEFAULT_MOBILE_LAYOUT, XplorTraderModules, xplorTraderTabIcon } from '@/utils/hooks/useXplorTraderLayout';
import { useMemo } from 'react';
import { IconType } from 'react-icons/lib';
import { updateTree } from 'react-mosaic-component';
import { mobileTabNavigationClassName, TabButton } from '../MobileTabNavigation';

const TraderMobileTabNavigation = () => {
    const dispatch = useAppDispatch();
    const mobileLayoutNode = useAppSelector(selectXplorTraderMobileLayoutNode) as any;
    const layout = useMemo(() => (mobileLayoutNode ? mobileLayoutNode : DEFAULT_MOBILE_LAYOUT), [mobileLayoutNode]);
    const lang = useLanguage();

    const tabs: {
        label: string;
        name: XplorTraderModules;
        Icon: IconType;
    }[] = useMemo(() => {
        return [
            {
                label: lang.locale === 'en' ? 'Tickers' : lang.modules.tickers,
                name: 'Tickers',
                Icon: xplorTraderTabIcon['Tickers']
            },
            {
                label: lang.locale === 'en' ? 'Depth' : lang.modules['order-book'],
                name: 'Order Book',
                Icon: xplorTraderTabIcon['Order Book']
            },
            {
                label: lang.locale === 'en' ? 'Chart' : lang.modules.chart,
                name: 'Chart',
                Icon: xplorTraderTabIcon['Chart']
            },
            {
                label: lang.locale === 'en' ? 'Blotters' : lang.modules.blotter,
                name: 'Blotter',
                Icon: xplorTraderTabIcon['Blotter']
            },
            {
                label: lang.locale === 'en' ? 'Account' : lang.modules['account-value'],
                name: 'Account Value',
                Icon: xplorTraderTabIcon['Account Value']
            }
        ];
    }, [lang]);

    return (
        <div className={mobileTabNavigationClassName}>
            {tabs.map((tab, index) => (
                <TabButton
                    key={tab.name}
                    Icon={tab.Icon}
                    isActive={layout?.second === tab.name}
                    onClick={() => switchTab(layout, tab.name, dispatch)}>
                    {tab.label}
                </TabButton>
            ))}
        </div>
    );
};

export default TraderMobileTabNavigation;

const switchTab = (mobileLayoutNode, moduleToDrop, dispatch) => {
    let currentNode = mobileLayoutNode;
    if (currentNode) {
        currentNode = updateTree(currentNode, [
            {
                path: [],
                spec: {
                    $set: {
                        direction: 'row',
                        first: '',
                        second: moduleToDrop,
                        splitPercentage: 0
                    }
                }
            }
        ]);
    } else {
        currentNode = moduleToDrop;
    }
    dispatch(setXplorTraderMobileLayoutNode(currentNode));
};
